import GlobalHeader from '../../common/components/Header/GlobalHeader'

function Shift() {
	return (
		<>
			<GlobalHeader />
			<div>Shift</div>
		</>
	)
}

export default Shift
